import { constant, find, findIndex, include, times } from 'lodash';

/* eslint-disable no-extend-native */

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/from
if (!Array.from) {
  Array.from = function (arrayLike, mapFn) {
    return mapFn ? Array(arrayLike.length).fill(1).map(mapFn) : [].slice.call(arrayLike);
  };
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/find
if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    return find(this, predicate);
  };
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function (predicate) {
    return findIndex(this, predicate);
  };
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement, fromIndex) {
    return include(this, searchElement, fromIndex);
  };
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
if (!Array.prototype.fill) {
  Array.prototype.fill = function (value) {
    return times(this.length, constant(value));
  };
}